import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as accountActions from 'reduxBits/account/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      objectCustom: undefined,
      event: 'event',
      eventType: 'Engagement',
      objectType: 'UIElement',
      objectFilterSearchNumResults: _.get(
        state,
        'classified.searchResults.searchTotal',
        '',
      ).toString(),
    },
    ...localData,
  })

export const overviewSavedAdClicked = {
  validators: [
    validators.redux(
      accountActions.OVERVIEW_SAVED_AD_CLICKED,
      () => true,
      ({ payload }) => payload,
    ),
  ],

  events: [
    gtm.event(({ state, accumulator }) => {
      return createDataLayerObject(state, {
        objectId: 'overview_saved_ad_clicked',
        objectName: 'Overview saved ad clicked',
        objectCustom: {
          savedAdIndex: _.get(state, 'account.savedAds.ads').findIndex(
            (o) => o.adId === _.get(accumulator, 'adId'),
          ),
        },
        target: {
          type: 'ClassifiedAd',
          id: _.get(accumulator, 'adId'),
          name: '',
          category: ' ',
        },
      })
    }),
  ],
}

export const savedAdClicked = {
  validators: [
    validators.redux(accountActions.SAVED_AD_CLICKED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) =>
      createDataLayerObject(state, {
        objectId: 'saved_ad_clicked',
        objectName: 'Saved ad clicked',
        objectCustom: {
          itemId: _.get(accumulator, 'adId'),
        },
        target: {
          type: 'ClassifiedAd',
          id: _.get(accumulator, 'adId'),
          name: '',
          category: ' ',
        },
        savedAdIndex: _.get(state, 'account.savedAds.ads').findIndex(
          (o) => o.adId === _.get(accumulator, 'adId'),
        ),
      }),
    ),
  ],
}

export const allAdWatchesClicked = {
  validators: [validators.redux(accountActions.ALL_ADWATCHES_CLICKED)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'all_adwatches_clicked',
        objectName: 'All adwatches clicked',
      }),
    ),
  ],
}
export const adWatchClicked = {
  validators: [
    validators.redux(accountActions.ADWATCH_CLICKED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) => {
      const query = _.get(accumulator, 'adwatchId', '').split('&')
      let adwatchId = undefined // eslint-disable-line no-undef-init
      query.forEach((element) => {
        const keyVal = element.split('=')
        if (keyVal[0] === 'w') {
          adwatchId = Number(keyVal[1])
        }
      })
      return createDataLayerObject(state, {
        objectId: 'adwatch_clicked',
        objectName: 'Adwatch clicked',
        objectCustom: {
          adWatchIndex: _.get(state, 'account.adWatches.items').findIndex(
            (o) => Number(o.adwatchId) === adwatchId,
          ),
        },
      })
    }),
  ],
}

export const adWatchAdClicked = {
  validators: [
    validators.redux(accountActions.ADWATCH_AD_CLICKED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) =>
      createDataLayerObject(state, {
        objectId: 'adwatch_clicked',
        objectName: 'Adwatch clicked',
        objectCustom: {
          adWatchAdIndex: _.get(state, 'account.adWatches.items').findIndex(
            (o) => o.adId === _.get(accumulator, 'adId'),
          ),
        },
      }),
    ),
  ],
}
